import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { reject } from 'lodash/collection';

import { STDT_TRAVEL, STTG_E_SOURCE } from '../../../../../../../constants/study/studyTypes';
import { NSPS_STUDY } from '../../../../../../../services/i18n/namespaces';

export default function CheckboxSelect({ group, selectedTypeIds, setSelectedTypeIds, studyType }) {
  const { t } = useTranslation(NSPS_STUDY, { keyPrefix: 'studyType.types' });
  const { typeParent, types } = group;
  return (
    <FormGroup name={typeParent + '_LABEL_ID'}>
      {types
        ?.filter(e => (studyType === STTG_E_SOURCE ? e.name !== STDT_TRAVEL : true))
        .map(({ id, type }) => {
          return (
            <FormControlLabel
              key={id}
              control={
                <Checkbox
                  checked={selectedTypeIds.includes(id)}
                  onChange={() =>
                    setSelectedTypeIds(function(prevIds) {
                      return prevIds.includes(id) ? reject(prevIds, pId => pId === id) : [...prevIds, id].sort();
                    })
                  }
                />
              }
              label={t(type)}
              sx={{ m: 0 }}
            />
          );
        })}
    </FormGroup>
  );
}
